import gsap from 'gsap'
import ScrollSmoother from 'gsap/ScrollSmoother'
import ScrollTrigger from 'gsap/ScrollTrigger'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import { desktop, mobile } from './check-res'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin)

let smoother

if (desktop) {
	smoother = ScrollSmoother.create({
		smooth: 2.5,
		speed: 0.65,
		effects: true,
		normalizeScroll: true,
	})
}

if (mobile) {
	smoother = ScrollSmoother.create({
		smooth: 2,
		speed: 0.8,
		normalizeScroll: true,
	})
}

// Scroll to sections
const scrollToBtns = document.querySelectorAll('[data-scroll-to]')
const scrollTl = gsap.timeline({
	defaults: {
		ease: 'power4.inOut',
		duration: 2,
	},
})

if (scrollToBtns) {
	scrollToBtns.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault()

			btn.disabled = true

			let section = btn.dataset.scrollTo
			let offset = smoother.offset(`#${section}`, 'top top')

			gsap
				.timeline({
					defaults: {
						ease: 'power4.inOut',
						duration: 2,
					},
				})
				.to(
					'.scroll-plug',
					{
						translateY: 0,
					},
					0
				)
				.to(
					'.scroll-plug__inner',
					{
						height: '100%',
					},
					'<+=0.05'
				)
				.to(
					window,
					{
						scrollTo: offset,
						duration: 0.1,
						ease: 'none',
					},
					'>'
				)
				.to(
					'.scroll-plug__inner',
					{
						height: '0%',
					},
					'>+=2'
				)
				.to(
					'.scroll-plug',
					{
						translateY: '-105%',
						onComplete: () => {
							scrollTl.restart()
							btn.disabled = false
						},
					},
					'<+=0.05'
				)
		})
	})
}

//

export { smoother }
